import {createAction, props} from '@ngrx/store';
import {LoadableComponent} from '../../../projects/layout/src/_interface/loadableComponent';
import {NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {IMedicineModalPayload} from 'app/_interfaces/modal-open-payload.interface';

export const openModalComponent = createAction(
	'[Modal] open',
	props<{component: LoadableComponent, modalOptions?: NgbModalOptions, openPayload?: IMedicineModalPayload}>()
);
export const closeModalComponent = createAction('[Modal] close', props<{closePayload?: any}>());
